module.exports = __webpack_public_path__ + "media/images/icon-close-8d3d6fa6e708275bf7e6100512cc76f6.svg";